import { render, staticRenderFns } from "./MainUserProfile.vue?vue&type=template&id=502a0314&scoped=true&"
import script from "./MainUserProfile.vue?vue&type=script&lang=js&"
export * from "./MainUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./MainUserProfile.vue?vue&type=style&index=0&id=502a0314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502a0314",
  null
  
)

export default component.exports